var $17d2ebb3e12bee4f$exports = {};
const $17d2ebb3e12bee4f$var$Configuration = {
    apiUrl: "https://api.hint.com",
    apiVersion: "20260320002013",
    emrNotesUrl: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com/prod",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com",
    emrCalendarsUrl: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com/prod",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com",
    emrMessagingUrl: "https://uivjk88z7e.execute-api.us-east-1.amazonaws.com/prod",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://uivjk88z7e.execute-api.us-east-1.amazonaws.com",
    env: "production",
    hintEnv: "production",
    fullStoryOrgId: "o-1T3FAV-na1",
    googleMapsKey: "AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4",
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784027700",
    release: "5f3ad2c554c262c1e4fe12d98d2b01746613f90d",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "production",
    sentryReleaseVersion: "5f3ad2c554c262c1e4fe12d98d2b01746613f90d",
    stripePublishableKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    statuspageEmbedCode: "8mxj6zhmjmzp",
    rainforestEnv: "production"
};
$17d2ebb3e12bee4f$exports = $17d2ebb3e12bee4f$var$Configuration;


window.CONFIGURATION = $17d2ebb3e12bee4f$exports;


//# sourceMappingURL=member-portal-elm.62c5ea02.js.map
